import { Gutter } from 'antd/lib/grid/row';

export const Category1Constants = {
  TYPES: {
    INGREDIENTS: 'Ingredients',
    PACKAGING_MATERIALS: 'Packaging Materials',
    OTHERS: 'Others',
  },
  NAME: 'category_1',
  SUCCESS_MESSAGE:
    'Category 1 details updated successfully. Please review Category 4 and 9 details.',
};
export const INGREDIENTS = {
  LABELS: {
    INGREDIENT: 'Enter ingredient name',
    ORIGIN: 'Enter ingredient origin',
    BEST_FIT_REGION: 'Select best fit production region',
    QUANTITY: 'Total quantity',
    COST: 'Total cost',
    UNIT: 'Unit',
    ORIGIN_SHARE: 'Origin share',
    PACKAGING: 'Enter packaging material name',
    OTHER: 'Enter other name',
    PACKAGING_ORIGIN: 'Enter packaging material origin',
    OTHER_ORIGIN: 'Enter other origin',
    FERTILISER: 'Enter fertilizer name',
    FERTILISER_ORIGIN: "Enter fertilizer origin"
  },
  ADD_ORIGIN: 'Add origin',
  GUTTER_VALUE: [30, 25] as Gutter,
};
